const BASE_URL = "https://contests-ladder-backend.onrender.com";

//  helper (centralized fetch)
const fetchJSON = async (url, options = {}) => {
  try {
    const res = await fetch(url, options);

    if (!res.ok) {
      throw new Error(`API error: ${res.status}`);
    }

    return await res.json();
  } catch (err) {
    console.error("API Error:", err);
    throw err;
  }
};

//
// Fetch Problems (Contest Drill)
//
export const fetchProblemsByQuestion = async (
  q,
  user_id,
  page = 1,
  limit = 20,
  search = "",
) => {
  let url = `${BASE_URL}/problems?page=${page}&limit=${limit}`;

  if (q) url += `&q=${q}`;
  if (user_id) url += `&user_id=${user_id}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  const res = await fetch(url);
  return res.json();
};

//
// 📌 Smart Practice (Rating Lab)
//
export const fetchSmartPractice = async ({
  min_rating,
  max_rating,
  limit,
  page = 1,
  user_id,
  search = "",
}) => {
  let url = `${BASE_URL}/smart-practice?page=${page}&limit=${limit}`;

  if (min_rating) url += `&min_rating=${min_rating}`;
  if (max_rating) url += `&max_rating=${max_rating}`;
  if (user_id) url += `&user_id=${user_id}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  const res = await fetch(url);
  return res.json();
};

//
// 📌 Mark Solved
//
export const markSolved = async (user_id, title_slug) => {
  return fetchJSON(`${BASE_URL}/mark-solved`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_id, title_slug }),
  });
};

//
// 📌 Mark Unsolved
//
export const markUnsolved = async (user_id, title_slug) => {
  return fetchJSON(`${BASE_URL}/mark-unsolved`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_id, title_slug }),
  });
};

//
// 📌 Fetch Solved Problems
//
export const fetchSolved = async (
  user_id,
  q,
  min_rating,
  max_rating,
  page = 1,
  limit = 20,
  search = "",
) => {
  let url = `${BASE_URL}/solved?user_id=${user_id}&page=${page}&limit=${limit}`;

  if (q) url += `&q=${q}`;
  if (min_rating) url += `&min_rating=${min_rating}`;
  if (max_rating) url += `&max_rating=${max_rating}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  const res = await fetch(url);
  return res.json();
};

//
// 📌 Streak
//
export const fetchStreak = async (user_id) => {
  return fetchJSON(`${BASE_URL}/streak/${user_id}`);
};

//
// 📊 Platform + user stats
//
export const fetchStats = async (user_id) => {
  const url = user_id
    ? `${BASE_URL}/stats?user_id=${user_id}`
    : `${BASE_URL}/stats`;
  return fetchJSON(url);
};

//
// 🔗 Sync LeetCode Progress
//
export const syncLeetCode = async (idToken, leetcodeUsername, questions, contestRating, contestsAttended) => {
  return fetchJSON(`${BASE_URL}/api/leetcode/sync`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ leetcodeUsername, questions, contestRating, contestsAttended }),
  });
};

//
// 🏆 Contest stats via backend (fallback when extension is not reloaded)
//
export const fetchContestStatsFromBackend = async (idToken) => {
  return fetchJSON(`${BASE_URL}/api/leetcode/contest-stats`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
};

//
// 🔖 Bookmarklet sync
//
export const createSyncToken = async (idToken) => {
  return fetchJSON(`${BASE_URL}/api/leetcode/create-sync-token`, {
    method: "POST",
    headers: { Authorization: `Bearer ${idToken}` },
  });
};

export const pollSyncStatus = async (token) => {
  return fetchJSON(`${BASE_URL}/api/leetcode/sync-status/${token}`);
};
